import Vue from 'vue'
import App from './App.vue'
import axios from 'axios';
import router from './router/index.js';
import * as appUtils from './core/appUtils';
import {HttpServer} from './core/http.server';
import { apis } from './core/apis';


Vue.config.productionTip = false

Vue.prototype.apis = apis.api;
Vue.prototype.appUtils = appUtils;
Vue.prototype.http = HttpServer;
Vue.prototype.axios = axios;

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')

